import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
const ClaimHeader = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">Action</TableCell>
                <TableCell> <TableSortLabel> Claim No.</TableSortLabel> </TableCell>
                <TableCell> <TableSortLabel> Amount</TableSortLabel> </TableCell>
                <TableCell> <TableSortLabel> Approver</TableSortLabel> </TableCell>
                <TableCell> <TableSortLabel> Clouser Date</TableSortLabel> </TableCell>
                <TableCell> <TableSortLabel> Primary Contact </TableSortLabel> </TableCell>
                <TableCell> <TableSortLabel> Remarks</TableSortLabel> </TableCell>
            </TableRow>
        </TableHead>
    )
}
export default ClaimHeader;